import { SparklesIcon } from "lucide-react";

import { Column, Row } from "@/components";

import { Call } from "@/types";

const PoweredByQuo = () => (
  <Row className="items-center gap-1 text-violet-500">
    <span className="text-xs font-medium">Powered by Quo</span>
    <SparklesIcon className="h-3.5 w-3.5" />
  </Row>
);

export const CallSummarySection = ({
  summary,
}: {
  summary: NonNullable<Call["summary"]>;
}) => {
  const summaryBullets = summary.summary ?? [];
  const nextSteps = summary.nextSteps ?? [];
  const hasSummaryBullets = summaryBullets.length > 0;
  const hasNextSteps = nextSteps.length > 0;

  /* Render */
  const render = () => {
    if (!hasSummaryBullets && !hasNextSteps) return null;

    return (
      <Column className="gap-4 rounded-lg border border-slate-200 p-4">
        {hasSummaryBullets && (
          <Column className="gap-2">
            <Row className="items-center justify-between">
              <p className="text-sm font-semibold text-slate-700">
                Call summary
              </p>
              <PoweredByQuo />
            </Row>
            <ul className="list-disc space-y-2 pl-5 marker:text-primary-800">
              {summaryBullets.map((bullet, i) => (
                <li key={i} className="text-sm text-slate-700">
                  {bullet}
                </li>
              ))}
            </ul>
          </Column>
        )}
        {hasNextSteps && (
          <Column className="gap-2">
            <Row className="items-center justify-between">
              <p className="text-sm font-semibold text-slate-700">Next steps</p>
              {!hasSummaryBullets && <PoweredByQuo />}
            </Row>
            <ul className="list-disc space-y-2 pl-5 marker:text-primary-800">
              {nextSteps.map((step, i) => (
                <li key={i} className="text-sm text-slate-700">
                  {step}
                </li>
              ))}
            </ul>
          </Column>
        )}
      </Column>
    );
  };

  return render();
};
